module.exports = __webpack_public_path__ + "static/media/acctiv_notif.06a61140.png";